document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".product-accordion .accordion-button");
  const collapses = document.querySelectorAll(".product-accordion .accordion-collapse");

  buttons.forEach(btn => {
    // ensure initial aria state matches "active" class if present
    const tgt = document.querySelector(btn.getAttribute("data-target"));
    if (btn.classList.contains("active")) {
      btn.setAttribute("aria-expanded", "true");
      tgt.classList.add("open");
    } else {
      btn.setAttribute("aria-expanded", "false");
      tgt.classList.remove("open");
    }

    btn.addEventListener("click", function() {
      const target = document.querySelector(btn.getAttribute("data-target"));

      // Close others (single-open)
      collapses.forEach(c => {
        if (c !== target) {
          c.classList.remove("open");
          const b = c.previousElementSibling?.querySelector(".accordion-button");
          if (b) {
            b.classList.remove("active");
            b.setAttribute("aria-expanded", "false");
          }
        }
      });

      // Toggle current
      const isOpen = target.classList.contains("open");
      if (isOpen) {
        target.classList.remove("open");
        btn.classList.remove("active");
        btn.setAttribute("aria-expanded", "false");
      } else {
        target.classList.add("open");
        btn.classList.add("active");
        btn.setAttribute("aria-expanded", "true");
      }
    });

    // keyboard: Enter / Space
    btn.addEventListener("keydown", function(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        btn.click();
      }
    });
  });
});